// extracted by mini-css-extract-plugin
export default {"suppliers-cell-renderer":"pzUNYXWQkqh_a5TwpU0e","supplier-name":"w3vJCkANUPSFmvcuJ7eC","supplier-count":"XTnJyfM9t0S3Knr3birx"};